import { executeSceneReaderLoop } from '../scenereader-loop';

/**
 * Fan-Out Engine specifically for SceneReader image queries.
 * Evaluates the pre-processed image data (Tags, OCR, Description) and asks sub-questions 
 * to determine the user's intent and provide actionable, intelligent responses instead of just narrating the tags.
 */
export async function executeSceneReaderFanOut(seedPrompt: string): Promise<string> {
    console.log(`[SceneReader Fan-Out] Expanding image prompt for deeper intent analysis.`);
    
    const subQueries = [
        "Based on the OCR text and description in the image, what specific task, error, or context is the user presenting?",
        "What are the logical next steps, troubleshooting advice, or deeper analysis required to resolve or explain the contents of this image?",
        "If this image contains an error message, UI element, or data, how can I best summarize the solution without just repeating the text?"
    ];
    
    let masterContextBlock = `\n[SYSTEM HARNESS CONTEXT: SCENEREADER INTENT FAN-OUT RESEARCH ACTIVATED.]\n`;
    masterContextBlock += `*Notice: The AI must use the following fan-out evaluations to answer the user intelligently rather than narrating the raw tags.* \n`;

    for (const query of subQueries) {
        // We simulate running these queries through the loop to evaluate the image context
        const data = await executeSceneReaderLoop(query);
        if (data) {
            masterContextBlock += `\n--- Sub-Query: ${query} ---\n${data}\n`;
        } else {
            masterContextBlock += `\n--- Sub-Query: ${query} ---\n[Evaluated context internally based on image tags]\n`;
        }
    }

    return masterContextBlock;
}
